import { useQuery } from "@tanstack/react-query";
import { getGeoAnalyticsData, getVenueGeofences } from "../../api/new-api";
import { sortFences, sortTiers, TimeRange, toMapFence } from "./geo-analytics-utils";

const STALE_TIME = 5 * 60 * 1000;

/** The geofences the venue monitors, alphabetical, with a marker position for each. */
export function useVenueFences(venueId: number | undefined) {
  return useQuery({
    queryKey: ["geo-fences", venueId],
    queryFn: async () => {
      const res = await getVenueGeofences();
      return sortFences((res.data.geofences ?? []).map(toMapFence));
    },
    enabled: venueId != null,
    staleTime: STALE_TIME,
  });
}

/**
 * Distinct members per venue per tier for the range. The previous range's figures stay on screen
 * while the next one loads, so the panels do not collapse on every filter click. Only for the same
 * venue: another venue's figures would be shown under this one's name.
 */
export function useTierCounts(venueId: number | undefined, range: TimeRange) {
  return useQuery({
    queryKey: ["geo-analytics", venueId, range.key],
    queryFn: async () => {
      const res = await getGeoAnalyticsData({
        daysAgo: range.daysAgo,
        hoursAgo: range.hoursAgo,
      });
      return sortTiers(res.data.geoData ?? []);
    },
    enabled: venueId != null,
    staleTime: STALE_TIME,
    placeholderData: (previous, previousQuery) =>
      previousQuery?.queryKey[1] === venueId ? previous : undefined,
  });
}
